import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";

import navEN from "./locales/en/nav.json";
import navFR from "./locales/fr/nav.json";
import commonEN from "./locales/en/common.json";
import commonFR from "./locales/fr/common.json";

i18n
  .use(LanguageDetector) // auto-detect user language
  .use(initReactI18next) // bind react-i18next
  .init({
    resources: {
      en: { nav: navEN, common: commonEN },
      fr: { nav: navFR, common: commonFR },
    },
    fallbackLng: "en",

    ns: ["nav", "common"],
    defaultNS: "common",

    interpolation: {
      escapeValue: false, // React already escapes
    },
    detection: {
      order: ["localStorage", "navigator", "htmlTag"],
      caches: ["localStorage"],
    },
  });

export default i18n;
